import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import './styles/global.css';
import App from './App.jsx';

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root'));

let lastErrorNotificationTime = 0;

// Sentry 초기화 (운영/검증 환경에서만)
if (!window.location.href.includes('localhost')) {
  Sentry.init({
    dsn: 'https://44664a14a7af0f51a5d5000fda92fdee@o4509672033288192.ingest.de.sentry.io/4509672040300624',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_APP_MODE === 'stg' ? 'production' : 'staging',
    release: import.meta.env.VITE_APP_VERSION || undefined,
  });
}

// 에러를 API로 전송하는 함수
const sendErrorToAPI = async error => {
  try {
    // localhost 알림X
    if (window.location.href.includes('localhost')) {
      return;
    }

    // 마지막 알림으로부터 30초가 지나지 않았으면 알림을 보내지 않음
    const currentTime = Date.now();
    if (currentTime - lastErrorNotificationTime < 30000) {
      return;
    }
    const environment = import.meta.env.VITE_APP_MODE === 'stg' ? '운영' : '검증';

    // 네트워크 에러일 경우 정보 추가
    const requestInfo = error?.requestInfo
      ? `\n[Request] url: ${error.requestInfo.url}\nmethod: ${error.requestInfo.method}\ndata: ${JSON.stringify(error.requestInfo.data)}`
      : '';

    const msg = `:exclamation: [FE ${environment}]\nurl: ${window.location.href}\nmsg: ${error?.message}\nstack: ${error?.stack}${requestInfo}`;

    await fetch(`${import.meta.env.VITE_APP_API_PATH}/editor/sendLog`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        msg: msg,
      }),
    });

    lastErrorNotificationTime = currentTime;
    console.log('에러 데이터를 API로 전송:', msg);
  } catch (apiError) {
    console.error('에러 API 전송 실패:', apiError);
  }
};

window.addEventListener('error', event => {
  console.error('전역 에러 발생:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
  });

  sendErrorToAPI(event.error);
});

window.addEventListener('unhandledrejection', event => {
  console.error('처리되지 않은 Promise 에러:', {
    reason: event.reason,
    promise: event.promise,
  });

  sendErrorToAPI(event.reason);
});

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>
);
